import { defaultIconProps, IconProps } from './IconProps';

export const IconAzure: import('react').FC<IconProps> = ({ size, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" fill="none" {...rest} xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2687_6302)">
      <path
        d="M13.0612 4.85227C13.1694 4.53078 13.3758 4.2514 13.6513 4.05357C13.9269 3.85575 14.2576 3.74948 14.5968 3.74977H24.7716L14.2103 35.0441C14.102 35.3651 13.8957 35.644 13.6204 35.8415C13.3452 36.0391 13.015 36.1453 12.6762 36.1452H4.75743C4.50009 36.1456 4.24636 36.0846 4.0173 35.9673C3.78823 35.85 3.59043 35.6798 3.4403 35.4708C3.29017 35.2618 3.19203 35.02 3.15404 34.7655C3.11604 34.5109 3.13927 34.251 3.2218 34.0073L13.0612 4.85227Z"
        fill="url(#paint0_linear_2687_6302)"
      />
      <path
        d="M29.329 24.8067H13.2917C13.1428 24.8072 12.9975 24.8524 12.8746 24.9365C12.7517 25.0206 12.6568 25.1396 12.6023 25.2781C12.5478 25.4167 12.5361 25.5684 12.5688 25.7137C12.6015 25.859 12.677 25.9911 12.7856 26.0929L23.0902 35.7106C23.3906 35.9906 23.7858 36.1452 24.1956 36.1452H33.2752L29.329 24.8067Z"
        fill="#0078D4"
      />
      <path
        d="M24.7717 3.74977H13.4331L2.5 36.1452H13.8385L16.166 29.2473L23.5569 36.1452H33.2767L29.329 24.8066H17.6652L24.7717 3.74977Z"
        fill="url(#paint1_linear_2687_6302)"
      />
      <path
        d="M27.5731 4.85227C27.465 4.53102 27.2588 4.2518 26.9835 4.054C26.7083 3.85619 26.3779 3.74978 26.0389 3.74977H14.6494H14.7004C15.396 3.74977 16.0129 4.1931 16.2346 4.85227L26.0754 34.0073C26.1579 34.2509 26.1811 34.5107 26.1432 34.7651C26.1053 35.0195 26.0073 35.2612 25.8573 35.4702C25.7074 35.6792 25.5098 35.8494 25.2809 35.9668C25.052 36.0842 24.7984 36.1453 24.5412 36.1452H24.3662H35.8798C36.137 36.1453 36.3905 36.0842 36.6194 35.9668C36.8483 35.8494 37.0459 35.6792 37.1959 35.4702C37.3458 35.2612 37.4438 35.0195 37.4818 34.7651C37.5197 34.5107 37.4964 34.2509 37.4139 34.0073L27.5731 4.85227Z"
        fill="url(#paint2_linear_2687_6302)"
      />
    </g>
    <defs>
      <linearGradient id="paint0_linear_2687_6302" x1="14.5268" y1="4.87123" x2="3.96118" y2="36.0854" gradientUnits="userSpaceOnUse">
        <stop stopColor="#114A8B" />
        <stop offset="1" stopColor="#0669BC" />
      </linearGradient>
      <linearGradient id="paint1_linear_2687_6302" x1="22.9779" y1="24.8154" x2="20.4725" y2="25.67" gradientUnits="userSpaceOnUse">
        <stop stopOpacity="0.3" />
        <stop offset="0.071" stopOpacity="0.2" />
        <stop offset="0.321" stopOpacity="0.1" />
        <stop offset="0.623" stopOpacity="0.05" />
        <stop offset="1" stopOpacity="0" />
      </linearGradient>
      <linearGradient id="paint2_linear_2687_6302" x1="21.2264" y1="4.87123" x2="32.8231" y2="35.7704" gradientUnits="userSpaceOnUse">
        <stop stopColor="#3CCBF4" />
        <stop offset="1" stopColor="#2892DF" />
      </linearGradient>
      <clipPath id="clip0_2687_6302">
        <rect width="35" height="35" fill="white" transform="translate(2.5 2.5)" />
      </clipPath>
    </defs>
  </svg>
);

IconAzure.defaultProps = defaultIconProps;
